export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return
  try {
    // Verifica se o arquivo SW está acessível corretamente (evita HTML sendo servido por rewrite)
    try {
      const resp = await fetch('/sw.js', { cache: 'no-store' })
      const ct = (resp.headers.get('content-type') || '').toLowerCase()
      if (!resp.ok) {
        ;(window as any).__SW_DIAG__ = 'sw_fetch_failed'
        return
      }
      if (ct.includes('text/html')) {
        ;(window as any).__SW_DIAG__ = 'sw_is_html'
        console.warn('[sw] sw.js retornou HTML (rewrite incorreto).')
        return
      }
      if (!ct.includes('javascript')) {
        ;(window as any).__SW_DIAG__ = 'sw_bad_mime:' + ct
        console.warn('[sw] sw.js com MIME inesperado:', ct)
        // Prosseguir somente se o navegador aceitar mesmo assim
      }
    } catch {
      ;(window as any).__SW_DIAG__ = 'sw_fetch_failed'
      return
    }
    // Tenta escopo alinhado ao start_url ('/app') e faz fallback para '/'
    try {
      // Força escopo raiz para cobrir todas as rotas (/dashboard-master, /profile, etc.)
      await navigator.serviceWorker.register('/sw.js', { scope: '/' })
    } catch (e2) {
      ;(window as any).__SW_DIAG__ = 'register_error:' + String((e2 as any)?.message || e2)
      console.warn('[sw] register error (/):', e2)
      return
    }

    // Se registrou, mas ainda não controla, tenta um único reload assistido
    try {
      const FLAG = 'pwa.sw.pending.reload'
      if (!(navigator as any).serviceWorker.controller) {
        ;(navigator as any).serviceWorker.addEventListener('controllerchange', () => {
          try { localStorage.removeItem(FLAG) } catch {}
        })
        const pending = (() => { try { return localStorage.getItem(FLAG) === '1' } catch { return false } })()
        if (!pending) {
          try { localStorage.setItem(FLAG, '1') } catch {}
          setTimeout(() => { location.reload() }, 400)
        }
      }
    } catch {}
  } catch (e) {
    ;(window as any).__SW_DIAG__ = 'register_error:' + String((e as any)?.message || e)
    console.warn('[sw] register error', e)
  }
}
